import type { StatusModel } from '../../api/vegApl';

const getFirstAvailableValue = (obj: any, keys: string[], fallback: any = null) => {
    for (const key of keys) {
        if (obj?.[key] !== undefined && obj?.[key] !== null && obj?.[key] !== '') {
            return obj[key];
        }
    }
    return fallback;
};

export const mapMaterialWithHarvestRows = (material: any, page: number, index: number, materialStatuses: StatusModel[] = []) => {
    const parentRowUid = `${page}-${index}`;
    const harvests = Array.isArray(material?.material_harvests) ? material.material_harvests : [];
    const materialStatusValue = getFirstAvailableValue(material, ['current_status', 'material_status', 'status'], '');
    const resolvedStatusId = getFirstAvailableValue(material, ['status_id', 'current_status_id', 'material_status_id'], null)
        ?? (typeof materialStatusValue === 'number'
            ? materialStatusValue
            : (materialStatuses.find((s: any) => String(s.status_value).toLowerCase() === String(materialStatusValue).toLowerCase())?.status_id ?? null));

    material['required_fruit'] = material['required_fruit_count'];
    const harvestCount = Array.isArray(material?.material_harvests) ? material.material_harvests.length : 0;

    const childRows = harvests.map((harvest: any, harvestIndex: number) => {
        const childUid = `${parentRowUid}-h-${harvestIndex}-${harvest?.material_harvest_id ?? 'na'}`;

        return {
            ...material,
            ...harvest,
            _rowUid: childUid,
            _rowType: 'child',
            _isNoDataRow: false,
            _parentRowUid: parentRowUid,
            _harvestIndex: harvestIndex + 1,
            'Material ID': `Harvest ${harvestIndex + 1}`,
            harvest_title: `Harvest ${harvestIndex + 1}`,
            harvest_name: getFirstAvailableValue(harvest, ['harvest_name', 'name'], `Harvest ${harvestIndex + 1}`),
            material_stage_code: `Harvest ${harvestIndex + 1}`,
            // Child rows must use the material_harvest `splot_id` key directly.
            splot_id: getFirstAvailableValue(harvest, ['splot_id'], ''),
            required_grams: getFirstAvailableValue(harvest, ['required_seed_weight_g', 'required_seed_weight', 'required_grams']),
            required_fruit: getFirstAvailableValue(harvest, ['required_fruit_count']),
            required_seed_count: getFirstAvailableValue(harvest, ['required_seed_count']),
            fruit_weight_g: getFirstAvailableValue(harvest, ['fruit_weight', 'fruit_weight_g', 'weight_g']),
            fruit_count: getFirstAvailableValue(harvest, ['fruit_count']),
            seed_count: getFirstAvailableValue(harvest, ['seed_count']),
            seed_weight_g: getFirstAvailableValue(harvest, ['seed_weight_g', 'seed_weight']),
            material_remark: getFirstAvailableValue(harvest, ['material_remark', 'remarks', 'remark_name']),
            remark_id: getFirstAvailableValue(harvest, ['remark_id']),
            remarks: getFirstAvailableValue(harvest, ['remark_id', 'material_remark', 'remarks', 'remark_name']),
            container_id: harvest?.registered_containers ?? getFirstAvailableValue(harvest, ['container_id', 'container_alt_id', 'container_uuid']),
            harvest_status: getFirstAvailableValue(harvest, ['status', 'harvest_status', 'current_status'], ''),
            parentChildRela: `${index}-${harvestIndex}`,
        };
    });

    return {
        ...material,
        required_grams: getFirstAvailableValue(material, ['required_seed_weight_g', 'required_seed_weight', 'required_grams']),
        harvest_count: harvestCount,
        current_status: resolvedStatusId ?? materialStatusValue ?? '',
        status_id: resolvedStatusId ?? material?.status_id ?? '',
        _rowUid: parentRowUid,
        _rowType: 'parent',
        _hasChildren: childRows.length > 0,
        _childRows: childRows,
    };
};
